import axios from "axios";
import {Customer} from "@/api/types";
import getApiDomain from "@/api/getApiDomain";

const getCustomers = async () => {
	const response = await axios.get<Customer[]>(getApiDomain() + "/api/customer", {
		headers: {
			'X-HTTP-AUTHORIZATION': `Authenticate ${localStorage.getItem("auth_token")}`,
			'Access-Control-Allow-Origin': '*',
		},
		validateStatus: function (status) {
			return status < 500; // Resolve only if the status code is less than 500
		}
	}).catch(function (e) {
		const error = e.toJSON();
		if(error.status !== 500){
			throw e;
		}
	});
	if(!response){
		return [];
	}
	return response.data;
};

export default getCustomers;
